import type { CSSProperties } from 'react'
import { cn } from '../primitives/util'

/**
 * Shimmer placeholder. Size via `width`/`height` (px or CSS string);
 * the shimmer collapses to a static block under prefers-reduced-motion
 * (global guard). Decorative — hidden from assistive tech.
 */

export interface SkeletonProps {
  width?: number | string
  height?: number | string
  /** Pill-shaped (avatars, badges). */
  rounded?: boolean
  /** Explicit border-radius (CSS value); takes precedence over `rounded`. */
  radius?: string
  className?: string
  style?: CSSProperties
}

export function Skeleton({
  width,
  height = 14,
  rounded = false,
  radius,
  className,
  style,
}: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('it-skeleton', className)}
      style={{
        width: width ?? '100%',
        height,
        borderRadius: radius ?? (rounded ? 'var(--r-pill)' : undefined),
        ...style,
      }}
    />
  )
}
